var map = {
	"./excalidraw-assets-dev/Assistant-Bold.woff2": 70165,
	"./excalidraw-assets-dev/Assistant-Medium.woff2": 7884,
	"./excalidraw-assets-dev/Assistant-Regular.woff2": 73047,
	"./excalidraw-assets-dev/Assistant-SemiBold.woff2": 94151,
	"./excalidraw-assets-dev/Cascadia.woff2": 61815,
	"./excalidraw-assets-dev/Virgil.woff2": 670,
	"./excalidraw-assets-dev/bug-issue-template-28bde25b78f0c2ca82bd.js": 34305,
	"./excalidraw-assets-dev/locales/ar-SA-json-e18bf994a8a492e04c5b.js": 39278,
	"./excalidraw-assets-dev/locales/bg-BG-json-c4822083b66facc7138b.js": 20087,
	"./excalidraw-assets-dev/locales/bn-BD-json-a19c78a329a982867a27.js": 31282,
	"./excalidraw-assets-dev/locales/ca-ES-json-81a1896a4b8113466237.js": 35741,
	"./excalidraw-assets-dev/locales/cs-CZ-json-bd241b199b5154d21ca1.js": 2959,
	"./excalidraw-assets-dev/locales/da-DK-json-4e6dd750a31d070daec9.js": 93041,
	"./excalidraw-assets-dev/locales/de-DE-json-d0676faf8f1e90d3ce34.js": 2267,
	"./excalidraw-assets-dev/locales/el-GR-json-9185ceab00e1598333d4.js": 11910,
	"./excalidraw-assets-dev/locales/es-ES-json-a2870461506d73f41a72.js": 68459,
	"./excalidraw-assets-dev/locales/eu-ES-json-3530634f7d5a3db297de.js": 8120,
	"./excalidraw-assets-dev/locales/fa-IR-json-66f5b4a41dc3aa7c8c45.js": 89098,
	"./excalidraw-assets-dev/locales/fi-FI-json-7885764c835895664e0b.js": 81433,
	"./excalidraw-assets-dev/locales/fr-FR-json-db1925f49529ff2c6ec1.js": 44652,
	"./excalidraw-assets-dev/locales/gl-ES-json-ab9c245372378f5f8c9b.js": 12502,
	"./excalidraw-assets-dev/locales/he-IL-json-7bfd6ca43596df3a84a1.js": 68947,
	"./excalidraw-assets-dev/locales/hi-IN-json-311afde0e51db172b1b4.js": 12144,
	"./excalidraw-assets-dev/locales/hu-HU-json-3f44c44bfef51d31102d.js": 60491,
	"./excalidraw-assets-dev/locales/id-ID-json-9328a35688d0537730ae.js": 82129,
	"./excalidraw-assets-dev/locales/it-IT-json-508f57463d4037918ebb.js": 69774,
	"./excalidraw-assets-dev/locales/ja-JP-json-c670cda6d6c171611c79.js": 83340,
	"./excalidraw-assets-dev/locales/kab-KAB-json-396d5e8936a8362b536c.js": 4725,
	"./excalidraw-assets-dev/locales/kk-KZ-json-7c301df4020cd7c670e2.js": 55743,
	"./excalidraw-assets-dev/locales/ko-KR-json-d6850be7bac8fc43af84.js": 26795,
	"./excalidraw-assets-dev/locales/ku-TR-json-9837b398f7df5f1bb711.js": 51064,
	"./excalidraw-assets-dev/locales/lt-LT-json-263c5629ddf0ee7d7572.js": 46885,
	"./excalidraw-assets-dev/locales/lv-LV-json-44a18e46e8c68310c7c8.js": 41697,
	"./excalidraw-assets-dev/locales/mr-IN-json-b0cd94322c2b39884d52.js": 57391,
	"./excalidraw-assets-dev/locales/my-MM-json-b0c8ffa53fa7c9f7fc4d.js": 93947,
	"./excalidraw-assets-dev/locales/nb-NO-json-216bb67091fd4a2e70e6.js": 15017,
	"./excalidraw-assets-dev/locales/nl-NL-json-820135e0dcbb62d8f23c.js": 42073,
	"./excalidraw-assets-dev/locales/nn-NO-json-059b39da1c7b19e93db6.js": 236,
	"./excalidraw-assets-dev/locales/oc-FR-json-54a63799c742875f8b9b.js": 43604,
	"./excalidraw-assets-dev/locales/pa-IN-json-e535caa54102fbcee393.js": 42774,
	"./excalidraw-assets-dev/locales/pl-PL-json-73e6bd0c53922c9c71ba.js": 24538,
	"./excalidraw-assets-dev/locales/pt-BR-json-f8d16d6d47abde7f52c8.js": 17369,
	"./excalidraw-assets-dev/locales/pt-PT-json-4b8554cd18248130c618.js": 67401,
	"./excalidraw-assets-dev/locales/ro-RO-json-718b6921865260332b51.js": 51095,
	"./excalidraw-assets-dev/locales/ru-RU-json-f941229aeb3c961f6afe.js": 97961,
	"./excalidraw-assets-dev/locales/si-LK-json-2f1de88a189ba6ba696d.js": 87038,
	"./excalidraw-assets-dev/locales/sk-SK-json-733bf7834531da06e409.js": 8407,
	"./excalidraw-assets-dev/locales/sl-SI-json-302c47db8bdde83cfd9a.js": 30688,
	"./excalidraw-assets-dev/locales/sv-SE-json-a3fbe43174a0b8c11dbe.js": 82150,
	"./excalidraw-assets-dev/locales/ta-IN-json-97dde0a466b7ef9a293c.js": 49187,
	"./excalidraw-assets-dev/locales/tr-TR-json-d387c2ab9f0dabccb94c.js": 42415,
	"./excalidraw-assets-dev/locales/uk-UA-json-9b412ee83d32be90b91b.js": 54219,
	"./excalidraw-assets-dev/locales/vi-VN-json-5d796333807e34aee311.js": 32965,
	"./excalidraw-assets-dev/locales/zh-CN-json-9089c24ecdc4c4b7c5cf.js": 95368,
	"./excalidraw-assets-dev/locales/zh-HK-json-66e5d1f5e052d9b895e2.js": 63360,
	"./excalidraw-assets-dev/locales/zh-TW-json-a05cd2023060266e8e0e.js": 63887,
	"./excalidraw-assets-dev/socketIoClient-fa4b6d469c39d45f2e09.js": 71512,
	"./excalidraw-assets-dev/vendor-fdc36bdf1a21c07b4941.js": 5020,
	"./excalidraw-assets/Assistant-Bold.woff2": 26913,
	"./excalidraw-assets/Assistant-Medium.woff2": 56517,
	"./excalidraw-assets/Assistant-Regular.woff2": 7424,
	"./excalidraw-assets/Assistant-SemiBold.woff2": 3003,
	"./excalidraw-assets/Cascadia.woff2": 7607,
	"./excalidraw-assets/Virgil.woff2": 76527,
	"./excalidraw-assets/bug-issue-template-7628a1d844446e5ca713.js": 49127,
	"./excalidraw-assets/locales/ar-SA-json-f62d0199267ac26dcc46.js": 51227,
	"./excalidraw-assets/locales/bg-BG-json-2dae80c8675231d2508f.js": 37007,
	"./excalidraw-assets/locales/bn-BD-json-7de0976b3dd235c50367.js": 74081,
	"./excalidraw-assets/locales/ca-ES-json-df30bc43d1809c17e950.js": 88830,
	"./excalidraw-assets/locales/cs-CZ-json-f99ec89695d02c158738.js": 77432,
	"./excalidraw-assets/locales/da-DK-json-129c5a554846dcec2446.js": 96735,
	"./excalidraw-assets/locales/de-DE-json-de8ce52f58b63b5d7cac.js": 52354,
	"./excalidraw-assets/locales/el-GR-json-42b124da4348680272cf.js": 75084,
	"./excalidraw-assets/locales/es-ES-json-1d54804f6846a77665e7.js": 9771,
	"./excalidraw-assets/locales/eu-ES-json-20bb942caf2be5fb31fa.js": 25437,
	"./excalidraw-assets/locales/fa-IR-json-dc0297c83b07d4e32c5d.js": 4660,
	"./excalidraw-assets/locales/fi-FI-json-4a39cbd2be73e7ef11ab.js": 32539,
	"./excalidraw-assets/locales/fr-FR-json-a6cca9c86e1695df72c5.js": 57374,
	"./excalidraw-assets/locales/gl-ES-json-e612f476ea04f792c0cb.js": 80046,
	"./excalidraw-assets/locales/he-IL-json-cdc633d78db32de9de16.js": 23406,
	"./excalidraw-assets/locales/hi-IN-json-7421bffd8a0b1b4baefd.js": 95280,
	"./excalidraw-assets/locales/hu-HU-json-a3ea1c20e0a94d91ce9a.js": 41676,
	"./excalidraw-assets/locales/id-ID-json-f6613f95abceb22d4334.js": 53605,
	"./excalidraw-assets/locales/it-IT-json-7c0884df61edb349074e.js": 12942,
	"./excalidraw-assets/locales/ja-JP-json-ef14f8d870b98cce213c.js": 50566,
	"./excalidraw-assets/locales/kab-KAB-json-4637f465a71f864f4541.js": 43842,
	"./excalidraw-assets/locales/kk-KZ-json-754a1a92ec1065f31d3d.js": 84865,
	"./excalidraw-assets/locales/ko-KR-json-bc46bfce6edd97614e6a.js": 20448,
	"./excalidraw-assets/locales/ku-TR-json-fdfa8b6bee1e0641bc22.js": 77281,
	"./excalidraw-assets/locales/lt-LT-json-d5269bb2d2b60fd38a5a.js": 77907,
	"./excalidraw-assets/locales/lv-LV-json-1d8885395dbcbd394b9d.js": 31153,
	"./excalidraw-assets/locales/mr-IN-json-80a3137f998226b197b5.js": 68298,
	"./excalidraw-assets/locales/my-MM-json-3d2e8072ecfc933ff405.js": 99307,
	"./excalidraw-assets/locales/nb-NO-json-c3d61f50504ac09dcc64.js": 1417,
	"./excalidraw-assets/locales/nl-NL-json-87c4bd52e9abb75aaaf4.js": 48045,
	"./excalidraw-assets/locales/nn-NO-json-92ac810aa0d36d73abd5.js": 37239,
	"./excalidraw-assets/locales/oc-FR-json-5ea7d0994898ab2c9f00.js": 29530,
	"./excalidraw-assets/locales/pa-IN-json-a1e20a0ff8fddca3d0f8.js": 69142,
	"./excalidraw-assets/locales/pl-PL-json-c93ff741bb4aca4676e9.js": 40480,
	"./excalidraw-assets/locales/pt-BR-json-5b53e5bc1e2745a96718.js": 35488,
	"./excalidraw-assets/locales/pt-PT-json-9be05fd920a91a610e9f.js": 7926,
	"./excalidraw-assets/locales/ro-RO-json-1a69dd60c4c802d6dcfc.js": 78636,
	"./excalidraw-assets/locales/ru-RU-json-fbb4c10ed14cf28c501a.js": 37741,
	"./excalidraw-assets/locales/si-LK-json-f21fa92c1726fda0c56b.js": 34701,
	"./excalidraw-assets/locales/sk-SK-json-02bfb6c6ae8657ba7c10.js": 45950,
	"./excalidraw-assets/locales/sl-SI-json-28142a1698858ae0423f.js": 60570,
	"./excalidraw-assets/locales/sv-SE-json-355010df9dd71e3815aa.js": 43517,
	"./excalidraw-assets/locales/ta-IN-json-aa8488d4a7eba863eafa.js": 19173,
	"./excalidraw-assets/locales/tr-TR-json-0647ae69354eacfcfe79.js": 7882,
	"./excalidraw-assets/locales/uk-UA-json-5c05732cd5338c4b299a.js": 78207,
	"./excalidraw-assets/locales/vi-VN-json-13f82887207123a51a6a.js": 70093,
	"./excalidraw-assets/locales/zh-CN-json-ccec3aebee2e2775a326.js": 58478,
	"./excalidraw-assets/locales/zh-HK-json-2f216981a653096b6541.js": 25174,
	"./excalidraw-assets/locales/zh-TW-json-d8becf928388ee71ea47.js": 83117,
	"./excalidraw-assets/socketIoClient-9dfbabed609bb6017f9b.js": 99250,
	"./excalidraw-assets/vendor-8ed6f0c8ac8c0bf831e2.js": 78006,
	"./excalidraw.development.js": 43292,
	"./excalidraw.production.min.js": 96489
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67113;